import ApiValues from '../url/apiurl'
import labels from '../../utils/constants/labels';
import Networking from '../../utils/api/apiaccess';
var axios = require('axios');
function getBasketListing(UserID) {

    return Networking.GetApi(`${ApiValues.getBasketList}userID=${UserID}&subscriptionType=0&investmentAmount=0&volatility=0&strategy=0`, "").then(result => { return result })
        .catch(function (error) {
            return { "status": "F", "message": labels.messages.apierror }
        });

}
export default getBasketListing
